import React from "react"
import styled from "styled-components"
import { Skeleton } from "@zendeskgarden/react-loaders"

const StyledSkeleton = styled(Skeleton)`
  background-color: ${props => props.theme.colors.search.loader};
`

const SearchLoader = () => (
  <div data-testid="dev-docs-search-results-loader">
    <StyledSkeleton width="52%" />
    <StyledSkeleton width="98%" />
    <StyledSkeleton width="25%" />
  </div>
)

export default SearchLoader
